// extracted by mini-css-extract-plugin
export default {"Title":"InfoPanel_Title__ZTkwN","Icon":"InfoPanel_Icon__ODBmO"};